import { Box, Center, Text } from '@mantine/core';
import { CaretDownIcon } from '@phosphor-icons/react';
import { useState } from 'react';

export function SupportCaseDescription({
  description,
}: {
  description: string;
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      pos="relative"
      style={{
        cursor: 'pointer',
      }}
      onClick={() => setExpanded((v) => !v)}
    >
      <Text
        lineClamp={expanded ? undefined : 4}
        size="sm"
        style={{ whiteSpace: 'pre-line' }}
      >
        {description}
      </Text>

      {!expanded && (
        <Box
          pos="absolute"
          left={0}
          right={0}
          bottom={0}
          h={60}
          style={{
            background:
              'linear-gradient(to bottom, rgba(255,255,255,0), var(--mantine-color-body) 80%)',

            pointerEvents: 'none',
          }}
        />
      )}

      <Center mt="xs">
        <Box
          px={8}
          py={2}
          style={{
            zIndex: 1000,
            borderRadius: 999,
            background: 'var(--mantine-color-default)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CaretDownIcon
            size={14}
            weight="bold"
            style={{
              transition: 'transform 150ms ease',
              transform: expanded ? 'rotate(180deg)' : undefined,
            }}
          />
        </Box>
      </Center>
    </Box>
  );
}
